export enum PublicOpenDataActionsEnum {
  PUBLIC_OPEN_DATA_GET_DATA = 'PUBLIC_OPEN_DATA_GET_DATA',
  PUBLIC_OPEN_DATA_SET_DATA = 'PUBLIC_OPEN_DATA_SET_DATA',
  PUBLIC_OPEN_DATA_SET_ACTIVE_TAB = 'PUBLIC_OPEN_DATA_SET_ACTIVE_TAB',
  PUBLIC_OPEN_DATA_GET_CHECKS_DATA = 'PUBLIC_OPEN_DATA_GET_CHECKS_DATA',
  PUBLIC_OPEN_DATA_SET_CHECKS_DATA = 'PUBLIC_OPEN_DATA_SET_CHECKS_DATA',
}
